export default function docsUrl(path) {
  return "https://reactnavigation.org/docs/".concat(path);
}